/* eslint-disable */
/* jscs:disable */
import {createApp, h} from 'vue';
import Fuse from 'fuse.js';
import App from './App.vue';
import router from './router';
import store from './store';
import './filters';

import '@fortawesome/fontawesome-free/css/all.css'
import vButton from '@/components/globals/ui/_v-button';
import vTable from '@/components/globals/ui/_v-table';
import vDropdown from '@/components/globals/ui/_v-dropdown';
import vCol from '@/components/globals/ui/_v-col';
import vCheckbox from '@/components/globals/ui/_v-checkbox';
import './js/bootstrap';
import './js/global';
import './js/columns';
import './js/titlecase';
import _ from 'lodash';


window.Fuse = Fuse;

/*-- Google Analytics --*/
let measurementId = '';
if (window.location.hostname === 'report.nih.gov') {
    measurementId = 'G-DWQG7PG7SL';;
} else if (window.location.hostname === 'report.stage.era.nih.gov') {
    measurementId = 'G-QPB24HD4CF';
} else {
    measurementId = 'G-SRX2MTZYQM';
}

var script = document.createElement('script');
script.src = 'https://www.googletagmanager.com/gtag/js?id='+measurementId;
document.head.appendChild(script);
script = document.createElement('script');
script.innerHTML = "window.dataLayer = window.dataLayer || []; \
	function gtag(){dataLayer.push(arguments);}	\
	gtag('js', new Date());	 \
	gtag('config', '" + measurementId + "');";
document.head.appendChild(script);

export const app = createApp({
    router,
    store,
    render: () => ( h(App)),
    async created () {
        
    },
}).use(router).use(store);

app.component("vButton", vButton); 
app.component("vTable", vTable); 
app.component("vDropdown", vDropdown); 
app.component("vCol", vCol); 
app.component("vCheckbox", vCheckbox); 
app.mount('#app');